import overlay1 from '@volumental/assets/images/scanner/chachaStep/overlay/overlay1.png';
import overlay2 from '@volumental/assets/images/scanner/chachaStep/overlay/overlay2.png';
import { type JSX } from 'react';
import { Overlay } from './camera-overlay-types';

export function CameraOverlay({ variant }: { variant: Overlay }): JSX.Element {
  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundImage: `url(${variant === Overlay.Placement1 ? overlay1 : overlay2})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    ></div>
  );
}
